import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { CustomerIntegrationQueryKeys } from "./keys";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ICustomerIntegration } from "../../models/CustomerIntegration/CustomerIntegration";

export default function useCustomerIntegrations(customerId: string) {
  const { get } = useApiHelper();

  const customerIntegrations = useQuery({
    queryKey: CustomerIntegrationQueryKeys.all(customerId),
    queryFn: () =>
      get<IDefaultResponse<ICustomerIntegration[]>>(
        `/customer/${customerId}/integrations`
      ).then((res) => res.data),
  });

  return {
    customerIntegrations,
  };
}
